(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			const slidesCount = slideshow.querySelectorAll(".swiper-slide").length;
			const autoplay =
				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
			const slideshowSwiper = new Swiper(slideshow, {
				// navigation: {
				// 	nextEl: ".swiper-button-next",
				// 	prevEl: ".swiper-button-prev",
				// },
				loop: slidesCount > 1,
				autoHeight: false,
				allowTouchMove: slidesCount > 1,
				pagination: slidesCount > 1 ? {
					el: slideshow.querySelector('.hero-slider-pagination'),
					bulletClass: 'swiper-bullet',
					bulletActiveClass: 'swiper-bullet-active',
					clickable: true,
				} : false,
			});
			if (autoplay && slidesCount > 1) {
				slideshowSwiper.autoplay.run();
				slideshowSwiper.autoplay.running = true;

				slideshow.addEventListener("mouseenter", () => {
					slideshowSwiper.autoplay.pause();
				});
				slideshow.addEventListener("mouseleave", () => {
					slideshowSwiper.autoplay.run();
				});
			}
			if (slidesCount > 1) {
				slideshow.classList.add("slideshow__swiper--multiple-slides");
			}
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
